import dynamic from "next/dynamic";
import { NuqsAdapter } from "nuqs/adapters/next/app";
import { Suspense } from "react";

import { Context } from "types/context/Context";

import { FormBlockType_formBlock } from "./queries/contentfulTypes/FormBlockType";

const AccessibilityForm = dynamic(
  () => import("@components/AfaForms/AccessibilityForm/AccessibilityForm"),
);
const ComplaintsForm = dynamic(() => import("@components/AfaForms/ComplaintsForm/ComplaintsForm"));
const ContactForm = dynamic(() => import("@components/AfaForms/ContactForm/ContactForm"));
const KRWebForm = dynamic(() => import("@components/AfaForms/KRWebForm/KRWebForm"));
const NewsletterForm = dynamic(() => import("@components/AfaForms/NewsletterForm/NewsletterForm"));
const TestpanelForm = dynamic(() => import("@components/AfaForms/TestpanelForm/TestpanelForm"));
const CalculateFPTForm = dynamic(
  () => import("@components/AfaForms/CalculateFPTForm/CalculateFPTForm"),
);
interface FormBlockProps {
  blockData: FormBlockType_formBlock;
  uniqueKey?: string;
  context: Context;
}

export type FormTypes = "defaultContactForm" | "eServicesContactForm";

export interface FormProps {
  contentfulPreviewEntryId?: string;
  formType?: FormTypes;
}

function FormComponent({ blockData }: { blockData: FormBlockType_formBlock }) {
  const { formId, formTitle, formDescription, simpleNewsletterVersion } = blockData;
  const previewEntryId = blockData?.sys?.id;
  switch (formId) {
    case "Kontaktformulär":
      return (
        <ContactForm contentfulPreviewEntryId={previewEntryId} formType="defaultContactForm" />
      );
    case "Kontaktformulär E-tjänster för arbetsgivare":
      return (
        <ContactForm contentfulPreviewEntryId={previewEntryId} formType="eServicesContactForm" />
      );
    case "Klagomålsformulär":
      return <ComplaintsForm contentfulPreviewEntryId={previewEntryId} />;
    case "Feedbackgruppen":
      return <KRWebForm contentfulPreviewEntryId={previewEntryId} />;
    case "Testpanel":
      return <TestpanelForm contentfulPreviewEntryId={previewEntryId} />;
    case "Tillgänglighetsformulär":
      return <AccessibilityForm contentfulPreviewEntryId={previewEntryId} />;
    case "Beräkning-föräldrarpenningtillägg":
      return <CalculateFPTForm contentfulPreviewEntryId={previewEntryId} />;

    default:
      return (
        <NewsletterForm
          formId={formId}
          title={formTitle}
          description={formDescription}
          simpleVersion={simpleNewsletterVersion}
          contentfulPreviewEntryId={previewEntryId}
        />
      );
  }
}

/**
 * Receives a form block and renders the appropriate form component based on the formId.
 */
export const FormBlock = ({ blockData }: FormBlockProps) => {
  return (
    <Suspense>
      <NuqsAdapter>
        <FormComponent blockData={blockData!} />
      </NuqsAdapter>
    </Suspense>
  );
};
export default FormBlock;
